export default __webpack_public_path__ + "static/media/pin-car.60a78150.svg";